import { CodeValueMessageArgInterface } from "@nts/std/interfaces";

export class CodeValueMessageArg implements CodeValueMessageArgInterface {

  constructor(
    public code?: string,
    public value?: string
  ) {

  }
}
